function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 425.45999,
  x2: 425.45999,
  y1: 507.37,
  y2: 441.04999,
  gradientUnits: "userSpaceOnUse",
  spreadMethod: "pad"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0358da"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#020576"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M400.8603 507.3695c-6.768-4.2755-12.0084-10.7492-14.7186-18.4184-1.3241-3.7457-2.0444-7.776-2.0444-11.9752 0-2.5047.2563-4.9493.7438-7.3088l.3002-1.3244c.2804-1.1361.6149-2.251 1.0004-3.3418 4.9164-13.9147 18.1601-23.8923 33.7422-23.9524l46.9321-.0003c-11.306 1.1183-19.2932 7.4106-25.9906 15.7136l-6.4828 8.2094c-.4672.0181-.9366.0272-1.408.0272h-12.9118c-6.6141.002-11.9753 5.3637-11.9753 11.9775 0 5.1888 3.2998 9.6063 7.9155 11.2694z",
  clipRule: "evenodd"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#06d0db",
  fillRule: "evenodd",
  d: "M4.215805 12.27205c.956092-2.70552 2.804775-4.98923 5.192359-6.4976l-.164217-.20793c-1.418686-1.8591-3.674472-1.64567-5.976049-1.68839l-2.967193-.0549 3.456386 15.25199c-.172083-.83259-.2625-1.69499-.2625-2.57859 0-1.48139.254104-2.90319.721214-4.22459"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)",
  transform: "matrix(.35278 0 0 -.35278 -132.005445 184.76313)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  fillRule: "evenodd",
  d: "M400.8603 507.3695c-6.768-4.2755-12.0084-10.7492-14.7186-18.4184-1.3241-3.7457-2.0444-7.776-2.0444-11.9752 0-2.5047.2563-4.9493.7438-7.3088l.3002-1.3244c.2804-1.1361.6149-2.251 1.0004-3.3418 4.9164-13.9147 18.1601-23.8923 33.7422-23.9524l46.9321-.0003c-11.306 1.1183-19.2932 7.4106-25.9906 15.7136l-6.4828 8.2094c-.4672.0181-.9366.0272-1.408.0272h-12.9118c-6.6141.002-11.9753 5.3637-11.9753 11.9775 0 5.1888 3.2998 9.6063 7.9155 11.2694z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#06d0db",
  fillRule: "evenodd",
  d: "M14.736023 12.52104c-1.628305.58671-2.792393 2.1451-2.792393 3.9756 0 2.3332 1.891299 4.22451 4.22459 4.22539h4.554964c.166298 0 .331997.003.496708.01zM32.675705 29.17113c-1.687183-4.77411-6.153953-8.23528-11.455813-8.4395l2.286971 2.89609c2.362678 2.92911 5.180364 5.1489 9.168842 5.54341"
});

var SvgLogoHeader = function SvgLogoHeader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    viewBox: "0 0 33 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoHeader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-header.62a66a6f.svg";
export { ForwardRef as ReactComponent };